import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Rx';
import {DirectoryService} from '../../../../services/directory.service';
import {ApiClientService} from '../../../../services/api-client.service';
import {Resident} from '../../../../types/data.types';
import {AbstractDetailedView} from '../abstract-detailed-view';
import {ApiResidentService} from '../../../../services/api-directory.service';
import {PhoneTransformer} from '../../../../services/transformer.service';
import {ConstantsService} from '../../../../services/constants.service';
import {UserService} from '../../../../views/admin/user/services/user.service';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {environment} from 'environments/environment';
import {AmenitiesService} from '../../../../services/amenities.service';
import {ParkingPassService} from '../../../../services/parking-pass.service';
import {CondomanagerService} from '../../../../services/condomanager.service';
import {AccountStatementDetails} from '../../../../types/interface.types';
import {AuthTokenService} from '../../../../services/auth-token.service';
import {EmailService} from '../../../../services/email.service';
import {filter, tap} from 'rxjs/operators';
import {AuthenticationService} from '../../../../services/authentication.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'resident-view',
    templateUrl: './resident-view.component.html',
    providers: [ApiResidentService]
})

export class ResidentViewComponent extends AbstractDetailedView implements OnInit, OnDestroy {
    title = 'Resident';
    primaryPhoneVal;
    residentGroupsCopy;
    multiselectSettings = {
        singleSelection: false,
        text: 'Select Groups',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true
    };
    refreshData: EventEmitter<any> = new EventEmitter();
    spinnerAvatar = false;
    avatarUploadDisabled = false;
    showInstructionsHistory = false;

    // account statement
    isShowAccountBalance = false;
    accountBalance: number = null;
    accountStatements: AccountStatementDetails[] = null;

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService,
        public apiResident: ApiResidentService,
        public userService: UserService,
        public http: Http,
        public amenitiesService: AmenitiesService,
        public parkingPassService: ParkingPassService,
        private condomanagerService: CondomanagerService,
        private authTokenService: AuthTokenService,
        private emailService: EmailService,
        private authenticationService: AuthenticationService
    ) {
        super(directoryService, api);
        this.refreshData.subscribe(() => {
            this.directoryService.getData();
            this.directoryService.toggleDetailedView(null, false);
        });
    }

    ngOnInit() {
        this.directoryService.getGroups();
        super.ngOnInit();
        this.directoryService.imageCaptured.subscribe(image => this.changeAvatar({target: {files: [image]}}));
    }

    ngOnDestroy() {
        this.directoryService.imageCaptured.observers = [];
        this.s.forEach((subscription: Subscription) => subscription.unsubscribe());
    }

    initData(data: Resident) {
        if (!data) return;

        this.data = null;
        setTimeout(() => {
            this.data = data;
            this.primaryPhoneVal = this.data.phones.find((item) => item.isPrimaryPhone === true);
            this.residentGroupsCopy = this.data.groups.slice();
        });
        this.getAccountStatement(data.buildingId, data.suiteNumber);
    }

    onSubmit(data: any): void {
        this.apiResident.updateItem(this.data.suiteUserId, data).subscribe(
            () => this.updateView(null, false),
            (error) => {
                if (error._body) {
                    const body = JSON.parse(error._body);
                    if (body.errors && body.errors.length > 0) {
                        body.errors.forEach(error => {
                            if (error.error == 'error.constraint.error.email.email_exists_for_building_and_suite.archived')
                                this.directoryService.restoreResident(this.data.suiteId, data.email, 'detailed');
                        });
                    }
                }
                this.api.errorHandler(error, 'Update failed!');
            }
        );
    }

    private getPrimaryPhone(data: Array<any>): string | boolean {
        if (data && data.length) {
            const primaryPhone = data.find(item => item.isPrimaryPhone);

            if (primaryPhone) {
                if (primaryPhone.phone.match('^[0-9]+$'))
                    return PhoneTransformer.stringToPhone(primaryPhone.phone);
                else
                    return primaryPhone.phone.substr();
            }
        }

        return false;
    }

    applyChanges(item, form, formField) {
        if (formField !== 'phones' && formField !== 'addresses' && formField !== 'email') {
            if (form.dirty) {
                item[formField] = form.value[formField];
            } else {
                this.setEditModeForAll(false);
            }
        }
        if (form.valid) this.setEditModeForAll(false);
    }

    resetPhones(phones) {
        this.data.phones = phones;
    }

    remove(id: number): void {
        const title = !this.directoryService.dateIsEarlierThanCurrent(this.data.moveOutDate) ? 'Move Out Resident' : 'Delete The Resident';
        const text = !this.directoryService.dateIsEarlierThanCurrent(this.data.moveOutDate) ? 'Are you sure you want to move out resident?' : 'Are you sure you want to completely delete resident? After that, you will not have ability to restore data.';
        swal(ConstantsService.getSwalConfig(title, text),
            () => {
                const url = this.directoryService.getUrl('remove');
                this.api.remove('domainBD', url + id).subscribe(
                    () => this.updateView('This resident has now been marked as moved out and therefore will no longer have access to their account.'),
                    (error) => this.api.errorHandler(error, 'Resident move out failed.')
                );
            }
        );
    }

    sendInvitation(isInvitation): void {
        this.directoryService.sendInvitationToTheResident(this.data, this.data.corporationNumber, isInvitation);
    }

    sendTestMessage() {
        const resident = this.data as Resident;
        console.log('resident', resident);

        this.emailService.sendEmail({
            sender: 'notice@maxcondoclub.ca',
            senderName: 'MaxCondoClub',
            attachments: [],
            message: `Hi [[RESIDENT_NAME]]<br><br>This is a test message.<br><br>Thank you`,
            pmEmail: this.authenticationService.user.email,
            pmMobilePhone: this.authenticationService.user.primaryPhone,
            pmName: this.authenticationService.user.fullName,
            recipients: [{
                name: resident.fullName,
                email: resident.email,
                type: resident.role,
                bdId: resident.id,
                status: 'in_progress',
                buildingAddress: resident.buildingAddress,
                buildingId: resident.buildingId,
                buildingName: resident.buildingName,
                suiteCommonElementsFee: resident.commonElementsFee,
                suiteId: resident.suiteId,
                suiteName: resident.suiteNumber,
            }],
            buildingId: [`${resident.buildingId}`],
            buildingName: resident.buildingName,
            buildingAddress: resident.buildingAddress,
            filters: JSON.stringify([this.data.getEmailFilters()]),
            replyTo: '',
            replyToName: '',
            subject: 'Test Message',
            status: 'in_progress',
            sendMeCopy: 0,
        })
            .pipe(
                tap(() => this.updateView('Test email has been sent successfully'))
            )
            .subscribe();
    }

    moveResidentOut(data) {
        this.directoryService.moveOutFormResident = {
            id: data.id,
            suiteId: data.suiteId,
            suiteNumber: data.suiteNumber,
            refreshEmitter: this.refreshData
        };
        this.directoryService.showMoveOutModal = true;
    }

    resetPassword(data) {
        this.directoryService.showResetPasswordModal = true;
        this.userService.userInResetPasswordModal = JSON.parse(JSON.stringify(data));
        //Needed for proper work in the modal
        this.userService.userInResetPasswordModal.id = this.userService.userInResetPasswordModal.oauthId;
    }

    changeAvatar(e) {
        this.spinnerAvatar = true;
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('File path should not be blank.');
                    return;
                }
                this.data.photo = res.path;
                this.onSubmit({photo: this.data.photo});
                this.spinnerAvatar = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.spinnerAvatar = false;
            }
        );
    }

    removeAvatar() {
        this.data.photo = '';
        this.onSubmit({photo: this.data.photo});
    }

    addInstructions(type) {
        this.directoryService.instructionsModalUser = this.directoryService.selectedItemData.id;
        this.directoryService.showAddInstructionsModal = true;
        this.directoryService.instructionsModalType = type == 'entry' ? 'entry_instruction' : 'vacation_instruction';
    }

    showInstructionsHistoryTrigger(show) {
        this.showInstructionsHistory = show;
        this.directoryService.selectedResidentInstructions.forEach(i => {
            i.visible = !!show;
        });
    }

    numberOfCurrentInstructions() {
        return this.directoryService.selectedResidentInstructions.filter(i => i.visible).length;
    }

    editInstruction(instruction) {
        this.directoryService.instructionsModalUser = this.directoryService.selectedItemData.id;
        this.directoryService.showAddInstructionsModal = true;
        this.directoryService.instructionsModalType = instruction.type;
        this.directoryService.instructionInInstructionsModal = instruction;
    }

    arrayFieldsSubmit(fieldName, data) {
        const formatted = {};
        const field = 'suite' + fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
        let otherResidentField = [];
        if (this.data[field])
            otherResidentField = this.data[field].filter(item => !data[fieldName].find(i => i.id == item.id) && item.user != this.data.id);
        data[fieldName] = data[fieldName].concat(otherResidentField);
        formatted[fieldName] = data[fieldName].map(item => ({
            user: (item.user || item.user === null) ? item.user : undefined,
            fieldValue: item.fieldValue
        }));
        const url = `/v1/suites/${this.data.suiteId}.json`;
        this.api.patch('domainBD', url, formatted).subscribe(
            (res) => this.updateView(this.title + ' successfully updated', false),
            (error) => this.api.errorHandler(error, 'Edit failed')
        );
    }

    /**
     * Retrieves account statement details
     */
    private getAccountStatement(buildingId: number, suiteNumber: string) {
        // force reset
        this.accountBalance = null;
        this.accountStatements = null;
        this.isShowAccountBalance = false;

        const params = {'per-page': 9999};

        this.condomanagerService.getStatementsList(buildingId, suiteNumber, params)
            .pipe(
                filter(response => !response.error),
                tap(result => {
                    this.accountStatements = result.entities;
                    this.accountBalance = result.balance;
                    this.isShowAccountBalance = result.finished;
                })
            )
            .subscribe();
    }

    /**
     * Shows up account statement details
     * in modal window
     */
    public showAccountBalanceModal() {
        this.condomanagerService.accountStatementModalDetails = this.accountStatements;
    }

    clickConsentInput() {
        document.getElementById('fileInput').click();
    }

    public onFileInput(file): void {
        file.preventDefault();
        if (file.target.files && file.target.files.length) {
            for (let i = 0; i < file.target.files.length; i++) {
                this.addImage({target: {files: [file.target.files[i]]}});
            }
        }
    }

    addImage(e) {
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        if (file.size > 1000000) {
            toastr.warning('Maximum document size is 1MB.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post(`${environment.domainAmenities}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('Document path should not be blank.');
                    return;
                }
                this.uploadConsent(this.data.id, res.path, true);
            },
            error => this.api.errorHandler(error, 'Upload file failed')
        );
    }

    uploadConsent(user, path, value) {
        if (value) {
            const data = {
                user: user,
                pathToPdf: path,
                isSigned: 1
            };
            const url = `/v1/consent.json`;
            this.api.post('domainBD', url, data).subscribe(
                res => {
                    this.directoryService.getData();
                    toastr.success('Consent has been uploaded successfully');
                },
                error => this.api.errorHandler(error, 'Failed to save electronic signature consent.')
            );
        } else {
            const url = `/v1/consent/${this.data.consent.id}.json`;
            this.api.remove('domainBD', url).subscribe(
                res => {
                    this.directoryService.getData();
                    toastr.success('Consent has been deleted successfully');
                },
                error => this.api.errorHandler(error, 'Failed to remove electronic signature consent.')
            );
        }
    }

    convertDate(date) {
        return date ? moment(date).format('YYYY-MM-DD') : '';
    }

    actionButtonIsNotAvailable() {
        return !(this.data.id && (this.data.isCanEdit || this.data.isCanDelete || this.data.maxTvUser ||
            (!this.directoryService.dateIsEarlierThanCurrent(this.data.moveOutDate) &&
                (this.directoryService.account.canUpdate('amenity') || this.directoryService.account.canUpdate('parking_pass')))));
    }

    takeImageFromWebcam(event) {
        event.stopPropagation();
        this.directoryService.showImageCaptureModal = true;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/detailed-view/resident-view/resident-view.component.ts